var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "confirmation"
    }
  }, [_c('h1', {
    staticClass: "mt-4 mb-8 text-center"
  }, [_vm._v("We've updated our agreements")]), _vm._v(" "), _c('img', {
    staticClass: "ml-auto mr-auto card-img",
    attrs: {
      "src": require("assets/images/card-half-transparent.png")
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "space-y-5"
  }, [_c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreeToAllTerms,
      expression: "agreeToAllTerms"
    }],
    attrs: {
      "id": "cardholder_agreements-input",
      "value": "cardholder_agreement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeToAllTerms) ? _vm._i(_vm.agreeToAllTerms, "cardholder_agreement") > -1 : _vm.agreeToAllTerms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.agreeToAllTerms,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "cardholder_agreement",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeToAllTerms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.agreeToAllTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.agreeToAllTerms = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "leading-5",
    attrs: {
      "for": "cardholder_agreements-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tI agree to Extra's\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Extra_Electronic_Communications_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("ESign Act Disclosure and Consent")]), _vm._v(".\n\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "inline-block mt-2"
  }, [_vm._v("I also agree to the following:")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 mr-4 sm-md:mr-0 sm-md:w-48 check-img",
    class: {
      checked: _vm.agreeToAllTerms
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Terms_of_Service')).apply(null, arguments);
      }
    }
  }, [_vm._v("Terms of Service")]), _vm._v("\n\t\t\t\t\t\t\t\tand\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Privacy_Policy')).apply(null, arguments);
      }
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), !_vm.memberProfile.patriot ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 mr-4 sm-md:mr-0 sm-md:w-48 check-img",
    class: {
      checked: _vm.agreeToAllTerms
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Cardholder_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("Evolve Bank's Debit Cardholder Agreement")]), _vm._v("\n\t\t\t\t\t\t\t\tand\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.getevolved.com/privacy-policy/"
    },
    on: {
      "click": _vm.onEvolvePrivacyLinkClick
    }
  }, [_vm._v("Privacy Policy")])])]) : _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 mr-4 sm-md:mr-0 sm-md:w-48 check-img",
    class: {
      checked: _vm.agreeToAllTerms
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Patriot_Cardholder_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("Patriot Bank's Debit Cardholder Agreement")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 mr-4 sm-md:mr-0 sm-md:w-48 check-img",
    class: {
      checked: _vm.agreeToAllTerms
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Standing_ACH_Authorization')).apply(null, arguments);
      }
    }
  }, [_vm._v("Standing ACH Authorization")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start space-x-3 ml-10"
  }, [_c('span', {
    staticClass: "h-16 mr-4 sm-md:mr-0 sm-md:w-48 check-img",
    class: {
      checked: _vm.agreeToAllTerms
    },
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leading-5"
  }, [_c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Recurring_ACH_Authorization')).apply(null, arguments);
      }
    }
  }, [_vm._v("Recurring ACH Authorization")])])])]), _vm._v(" "), _c('button', {
    staticClass: "mt-8 text-lg leading-6 border-none",
    class: !_vm.readyToSubmit ? 'disabled button--gray button--filled' : 'button--mint button--filled',
    attrs: {
      "disabled": !_vm.readyToSubmit,
      "type": "submit",
      "name": "confirm-plan"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.continueButtonAction.apply(null, arguments);
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tI Agree & Acknowledge\n\t\t\t\t\t")])])]), _vm._v(" "), _c('small', {
    staticClass: "my-4 mt-4 text-sm leading-5 opacity-50 text-center"
  }, [_vm._v("\n\t\t\t\tYou can access these documents in the Extra app\n\t\t\t")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };